import { Capacitor } from "@capacitor/core";

import { WebShareContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

// The Android WebView has no Web Share API, so native goes through the Capacitor
// plugin. Web stays on `navigator.share`: the plugin's web layer drops `files`, so it
// could not share a screenshot.
export const WebShareProvider = createStaticContextProvider(
  WebShareContext,
  lazyValue(() =>
    Capacitor.isNativePlatform()
      ? import("./native-share").then((module) => module.nativeShare)
      : import("./browser-share").then((module) => module.browserShare),
  ),
);
